export const MESSAGE_ADDED = 'message-added'
export const MESSAGE_UPDATED = 'message-updated'
export const MESSAGE_DELETED = 'message-deleted'

export const LAST_MESSAGE_ID = 'last-message-id-updated'